import React from 'react';
import { PageTrackerWrapper } from 'queries/user/track';
import { ClassroomsProvider } from 'containers/App/context/ClassroomsContext';
import DashboardComponent from 'containers/Dashboard/Loadable';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import { EventCustomFieldDefinitionsProvider } from 'containers/App/context/EventCustomFieldDefinitionsContext/EventCustomFieldDefinitionsProvider';

export const DashboardRoutes = {
  path: 'dashboard',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.dashboard" />
      <PageTrackerWrapper title="Tableau de bord">
        <ClassroomsProvider>
          <EventCustomFieldDefinitionsProvider>
            <DashboardComponent />
          </EventCustomFieldDefinitionsProvider>
        </ClassroomsProvider>
      </PageTrackerWrapper>
    </>
  ),
};
